import { StatusCodes } from 'http-status-codes';
import React, { useState } from 'react';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import FnbApi from '~/src/services/api/FnbApi';

interface Props {
  dataItemId: string;
  onUpdate?: () => void;
  isBig?: boolean;
}
export default function SyncFnbOrder({ dataItemId, onUpdate, isBig = true }: Props): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  const [resultMessage, setResultMessage] = useState<string | null>(null);

  return (
    <>
      <SecondaryButton
        title="Update"
        onClick={async (): Promise<void> => {
          setLoading(true);
          var res = await FnbApi.updateFnbOrder(dataItemId);
          if (res.status === StatusCodes.OK) {
            if (res.data.result) {
              if (onUpdate) {
                onUpdate();
              }
            } else {
              setResultMessage(res.data.message);
            }
          }
          // setNewData(dataItemId);
          // newData = dataItemId;
          setLoading(false);
        }}
        // {...rest}
        isSubmitting={loading}
        size="sm"
      />
      {resultMessage && <div>{resultMessage}</div>}
    </>
  );
}
